export default __webpack_public_path__ + "static/media/grafema_capitolio_05.a12db4b0.jpg";